class UserInfo {
  constructor(id,userid,email,postion,job,hobby,photo,big_img,name,follow,followers,bio,age,story,notifyAll) {
    this.id = id;
    this.userid = userid;
    this.email = email;
    this.postion = postion;
    this.job = job;
    this.hobby = hobby;
    this.photo = photo;
    this.big_img = big_img;
    this.name = name;
    this.follow = follow;
    this.followers = followers;
    this.bio = bio;
    this.age = age;
    this.story = story;
    this.notifyAll = !!notifyAll;
  }
}
export default UserInfo;
